/* jshint esversion: 8 */
(function (QuidPro, $, undefined) {
  // #region Constants & properties
  const qp = QuidPro;
  const PORTALS_URL = "DesktopModules/QuidPro/API/QuidProApi/GetPortalList";

  Object.defineProperty(qp, "headers", {
    get() {
      return {
        ModuleId: sessionStorage.getItem("__ModuleId"),
        TabId: sessionStorage.getItem("__TabId"),
        Locale: sessionStorage.getItem("__Locale"),
      };
    },
  });
  // #endregion Constants & properties

  // #region Initialization
  setPortals();
  setPasswordField();
  setSplashScreen();
  // #endregion Initialization

  // #region Functions & methods
  async function getPortals() {
    const response = await fetch(PORTALS_URL, {
      method: "get",
      headers: qp.headers,
    }).then((response) => {
      return response.json();
    });

    return response;
  }

  async function setPortals() {
    const bUSwitcher = document.getElementById("businessUnitSwitcher");
    const buSwitcherWrapper = document.getElementById(
      "businessUnitSwitcherWrapper"
    );
    const buSwitcherList = document.getElementById("buSwitcher");
    const portalSearch = document.getElementById("buSwitcherSearch");
    const portals = await getPortals();
    portals.forEach((portal) => {
      let li = document.createElement("li");
      let a = document.createElement("a");
      a.className = "c-bu-switcher__dropdown-item";
      a.href = `https://${portal.url}`;
      a.innerHTML = portal.label;
      li.append(a);
      buSwitcherList.append(li);
    });

    bUSwitcher.addEventListener("click", handleShowBuSwitcher);
    document.addEventListener("click", (e) => {
      const isClickInside =
        buSwitcherWrapper.contains(e.target) || bUSwitcher.contains(e.target);
      if (!isClickInside) {
        buSwitcherWrapper.classList.add("hidden");
      }
    });

    function handleShowBuSwitcher(e) {
      e.preventDefault();
      buSwitcherWrapper.classList.toggle("hidden");
    }

    if (portals.length > 10) {
      portalSearch.style.display = "block";
      portalSearch.addEventListener("keyup", handleSearch);
    }

    function handleSearch(e) {
      const search = e.target.value.toLowerCase();
      const buSwitcherItems = document.querySelectorAll(
        ".c-bu-switcher__dropdown-item"
      );
      buSwitcherItems.forEach((item) => {
        const text = item.textContent.toLowerCase();
        if (text.indexOf(search) !== -1) {
          item.parentElement.classList.remove("h-hidden");
        } else {
          item.parentElement.classList.add("h-hidden");
        }
      });
    }
  }

  /**
   * Sets the password field to a password type and adds a show/hide password button.
   * @param {string} selector The selector for the password field.
   */
  function setPasswordField(selector) {
    if (typeof selector === "undefined") {
      selector = 'input[id$="DNN_txtPassword"]';
    }

    if (typeof selector !== "string") {
      throw new Error("The selector must be a string.");
    }

    const passwordField = document.querySelector(selector);

    if (passwordField === null) {
      throw new Error("The selector did not match any elements.");
    }

    const eyeClosed = `<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M21 9c-2.4 2.667 -5.4 4 -9 4c-3.6 0 -6.6 -1.333 -9 -4"></path><path d="M3 15l2.5 -3.8"></path><path d="M21 14.976l-2.492 -3.776"></path><path d="M9 17l.5 -4"></path><path d="M15 17l-.5 -4"></path></svg>`;
    const eyeOpened = `<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><path d="M12 4c4.29 0 7.863 2.429 10.665 7.154l.22 .379l.045 .1l.03 .083l.014 .055l.014 .082l.011 .1v.11l-.014 .111a.992 .992 0 0 1 -.026 .11l-.039 .108l-.036 .075l-.016 .03c-2.764 4.836 -6.3 7.38 -10.555 7.499l-.313 .004c-4.396 0 -8.037 -2.549 -10.868 -7.504a1 1 0 0 1 0 -.992c2.831 -4.955 6.472 -7.504 10.868 -7.504zm0 5a3 3 0 1 0 0 6a3 3 0 0 0 0 -6z" stroke-width="0" fill="currentColor"></path></svg>`;
  
    const toggleButton = document.createElement("button");
    toggleButton.className = "c-password-toggle";
    toggleButton.type = "button";
    toggleButton.innerHTML = eyeClosed;
    toggleButton.setAttribute("aria-label", "Show password");
    toggleButton.setAttribute("aria-pressed", "false");
    toggleButton.setAttribute("title", "Show password");
    toggleButton.setAttribute("tabindex", "-1");
    toggleButton.addEventListener("click", togglePassword);

    passwordField.parentElement.append(toggleButton);
    passwordField.setAttribute("type", "password");
    
    function togglePassword(e) {
        e.preventDefault();
        if (passwordField.getAttribute("type") == "password") {
            passwordField.setAttribute("type", "text");
            toggleButton.innerHTML = eyeOpened;
            toggleButton.setAttribute("aria-label", "Hide password");
            toggleButton.setAttribute("title", "Hide password");
        } else {
            passwordField.setAttribute("type", "password");
            toggleButton.innerHTML = eyeClosed;
            toggleButton.setAttribute("aria-label", "Show password");
            toggleButton.setAttribute("title", "Show password");
        }
    }
  }

  /**
   * Yoink the splash screen SVG and add it to the page.
   */
  function setSplashScreen() {
    const loadingDiv = document.querySelector(".dnnLoading");
    const loadingLogo = document.querySelector("#loadingLogo");

    loadingDiv.appendChild(loadingLogo);
  }

  // #endregion Functions & methods
})((window.QuidPro = window.QuidPro || {}), jQuery);
